// extracted by mini-css-extract-plugin
export default {"edit":"OrderDetail_edit__BVlVQ","close":"OrderDetail_close__I4jPv","buttons_box":"OrderDetail_buttons_box__EV-oF"};